import { render, staticRenderFns } from "./RecipientList.vue?vue&type=template&id=370a1f10&"
import script from "./RecipientList.vue?vue&type=script&lang=ts&"
export * from "./RecipientList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports